// EmptyStateWrapper.tsx
import { useParentOrganizationContext } from 'context/ParentOrganisationContext';
import { CompanySetupEnum } from 'enums/CompanySetupEnums';
import React from 'react';
import EmptyStateComponent from 'shared/components/EmptyStateComponent';
import styles from '../organisation.module.scss';

interface EmptyStateWrapperProps {
  loading: boolean;
  handleOrgModal: () => void;
  setLocationModal: (isVisible: boolean) => void;
}

export const EmptyStateWrapper: React.FC<EmptyStateWrapperProps> = ({
  loading,
  handleOrgModal,
  setLocationModal,
}) => {
  const handleLocationModal = () => setLocationModal(true);
  const { organizationData } = useParentOrganizationContext();
  if (!organizationData || loading) {
    return null;
  }
  if (!organizationData?.organization) {
    return (
      <div className={styles.organisationContainer}>
        <div className={styles.parentOrgBox} onClick={handleOrgModal}>
          <EmptyStateComponent
            title={CompanySetupEnum.AddParentOrgTitle}
            subTitle={CompanySetupEnum.AddParentOrgSubTitle}
          />
        </div>
      </div>
    );
  }

  if (!organizationData?.company?.hasLocations) {
    return (
      <div className={styles.organisationContainer}>
        <div className={styles.parentOrgBox} onClick={handleLocationModal}>
          <EmptyStateComponent
            title={CompanySetupEnum.AddLocTitle}
            subTitle={CompanySetupEnum.AddLocSubTitle}
          />
        </div>
      </div>
    );
  }

  return null;
};
